import { App, Post } from '@/services/types'
import { AppMutations } from './types'

const mutations: AppMutations = {
  setApps(state, apps: App[] | null): void {
    state.apps = apps
  },
  setSelectedAppPosts(state, posts: Post[]): void {
    state.selectedAppPosts = posts
  },
  setSelectedApp(state, app: App | null): void {
    state.selectedApp = app
  },
  setVisibilityMenu(state, value): void {
    state.showMenu = value
  }
}

export default mutations
